export const isStringOnlyWhitespace = (str) => !/\S/.test(str)
export const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);
export const humanize = (str) => {
  return str
    .replace(/_/g, ' ')                  // Replace underscores with spaces
    .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize first letter of each word
};